import { QueryKey } from 'query';

export const DASHBOARD = 'dashboard';
const METRICS = 'metrics';
const SUMMARY = 'summary';
const FILTERS = 'filters';
export const businessKey = new QueryKey(DASHBOARD);

export const chart = businessKey.chart();
export const metrics = businessKey.all(METRICS);
export const summary = businessKey.exact(SUMMARY);
export const filters = businessKey.exact(FILTERS);
